<template>
  <Modal v-model="connectionLost">
    <p class="pb-2 text-2xl font-bold leading-tight">
      {{ $t('popups.lostConnection.title') }}
    </p>
    <p class="pb-5 text-sm leading-tight xl:pb-8">
      {{ $t('popups.lostConnection.description', brandInfo) }}
    </p>

    <Button
      :href="backToLHLink"
      variant="secondary"
    >
      {{ $t('popups.lostConnection.returnToLHButton', brandInfo) }}
    </Button>
  </Modal>
</template>

<script>
import LostConnectionPopup from '~app/psp/base/lost-connection-popup.ts'
import Modal from '~brand-components/brussels/modal/modal.vue'
import Button from '~brand-components/brussels/button/button.vue'

export default LostConnectionPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
